import { createSlice } from '@reduxjs/toolkit';
import { getGroupKeyFromMenu } from 'configs/settingsConfig';

/**
 * 설정 Drawer 상태 관리 슬라이스
 *
 * 상태:
 * - isOpen: Drawer 열림 상태
 * - selectedMenu: 선택된 메뉴 키
 * - selectedGroup: 선택된 그룹 키
 */

const initialState = {
  isOpen: false,
  selectedMenu: 'saveOption',
  selectedGroup: 'model'
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    /** 설정 Drawer 열기 */
    openSettings: (state, action) => {
      state.isOpen = true;
      if (action.payload?.menu) {
        state.selectedMenu = action.payload.menu;
        state.selectedGroup = getGroupKeyFromMenu(action.payload.menu);
      }
    },

    /** 설정 Drawer 닫기 */
    closeSettings: (state) => {
      state.isOpen = false;
    },

    /** 선택된 메뉴 변경 */
    setSelectedMenu: (state, action) => {
      state.selectedMenu = action.payload;
      state.selectedGroup = getGroupKeyFromMenu(action.payload);
    },

    /** 선택된 그룹 변경 */
    setSelectedGroup: (state, action) => {
      state.selectedGroup = action.payload;
    }
  }
});

export const {
  openSettings,
  closeSettings,
  setSelectedMenu,
  setSelectedGroup
} = settingsSlice.actions;

export default settingsSlice.reducer;
